import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError } from '@unfoldrtech/portal-mic'
import {
  IUserProfile,
  IUserProfileUpdate,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId } from '../../utils/helpers'
import { coreAPIV3 } from '../../services/coreAPIV3'

type TPatchUserProfileMutationResult = UseMutationResult<
  AxiosResponse<IUserProfile>,
  AxiosError<IError>,
  {
    payload: IUserProfileUpdate
  }
>

export const usePatchUserProfile = () => {
  return useMutation([`patchUserProfile`], (params) =>
    coreAPIV3.users().patchUserProfile(generateCorrelationId(), params.payload)
  ) as TPatchUserProfileMutationResult
}
